import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full overflow-hidden rounded-lg shadow-xs" }
const _hoisted_2 = { class: "w-full overflow-x-auto" }
const _hoisted_3 = { class: "bg-gray-50 py-3 flex w-full justify-between" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "w-full h-full whitespace-no-wrap"
}
const _hoisted_6 = { class: "text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bg-white dark:divide-gray-700 dark:bg-gray-800" }
const _hoisted_9 = {
  key: 0,
  class: "flex-column relative h-full justify-center items-center"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(`px-4 py-4 text-sm `)
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "flex relative h-full items-center" }
const _hoisted_17 = { class: "flex h-full absolute top-0 justify-start items-center space-x-4 text-sm" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 1,
  class: "bg-gray-100 text-center font-medium py-3 flex justify-center items-center opacity-25"
}
const _hoisted_26 = { class: "px-4 py-3 flex justify-between text-xs font-semibold h-full w-full tracking-wide text-gray-500 uppercase border-t dark:border-gray-700 bg-gray-50 sm:grid-cols-9 dark:text-gray-400 dark:bg-gray-800" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center col-span-3"
}
const _hoisted_28 = { class: "flex col-span-4 sm:justify-end" }
const _hoisted_29 = { "aria-label": "Table navigation" }
const _hoisted_30 = { class: "inline-flex items-center" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.perView) = $event)),
          class: "block px-3 mt-1 text-sm border bg-white form-select focus:border-gray-200 focus:outline-none focus:shadow-outline-green dark:focus:shadow-outline-gray rounded-md"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("option", {
              key: i,
              value: i * 5
            }, _toDisplayString(i * 5), 9, _hoisted_4)
          }), 64))
        ], 512), [
          [_vModelSelect, $setup.perView]
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.query) = $event)),
            class: "border rounded-md p-2 text-sm",
            placeholder: "Search"
          }, null, 512), [
            [_vModelText, $setup.query]
          ]),
          ($props.exports)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-sm bg-primary p-2 rounded-sm text-white ml-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.exportCSVFile($props.headers, $setup.copyData, 'table')))
              }, [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Exportar para ", -1),
                _createElementVNode("b", null, "CSV", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
      ($setup.copyData && $props.data && $setup.copyData.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.headers, (header) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: header.value,
                    class: "px-4 py-4"
                  }, [
                    _createElementVNode("div", {
                      class: "flex items-center cursor-pointer",
                      onClick: () =>
                  $setup.sortTable(
                    $setup.stateSort == 'dec' ? 'asc' : 'dec',
                    header.value,
                    typeof $setup.copyData[0][header.value]
                  )
                  
                    }, [
                      _createTextVNode(_toDisplayString(header.key) + " ", 1),
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "gg-swap-vertical ml-2" }, null, -1))
                    ], 8, _hoisted_7)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.copyData, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item,
                  class: _normalizeClass(`text-gray-700 ${index % 2 != 0 ? 'bg-gray-100' : ''
              } dark:text-gray-400`)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.headers, (object) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: object }, [
                      (object.photo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("img", {
                              class: "h-10 w-10 absolute top-1.5 rounded-md",
                              src: item[object.value]
                            }, null, 8, _hoisted_10)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (object.value != '')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                                  (object.date)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(object.deep
                        ? $setup.toDate($setup.deep(item, object.value))
                        : $setup.toDate(item[object.value])), 1))
                                    : (object.money)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.toMoney(item[object.value])), 1))
                                      : (object.color)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                            _createElementVNode("div", {
                                              style: _normalizeStyle(`height: 25px; width: 25px; background-color: ${item[object.value]}; border-radius: 5px`)
                                            }, null, 4)
                                          ]))
                                        : (object.document)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                              (item[object.value].length > 11)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(_toDisplayString($setup.numberToCnpj(item[object.value])), 1)
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString($setup.numberToCpf(item[object.value])), 1)
                                                  ], 64))
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 4,
                                              class: _normalizeClass(` ${object.badge
                      ? `px-3 py-1 rounded-full text-white capitalize bg-${object.badge[item[object.value]]
                      }-500`
                      : ''
                      }`)
                                            }, _toDisplayString(object.deep
    ? $setup.deep(item, object.value).length > 0
      ? $setup.deep(item, object.value)
      : ""
    : object.badge
      ? item[object.value] === 1 ? "Ativado" : item[object.value]
      : item[object.value]), 3))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ], 64))
                  }), 128)),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: option.icon
                        }, [
                          (option.icon === 'trash')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (option.action(item))
                              }, [
                                _createElementVNode("i", {
                                  title: option.title,
                                  class: _normalizeClass(`gg-${option.icon} mx-3 cursor-pointer hover:text-primary`)
                                }, null, 10, _hoisted_19)
                              ], 8, _hoisted_18))
                            : (option.icon === 'block' && option.use === 'active')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  onClick: ($event: any) => (option.action(item))
                                }, [
                                  _createElementVNode("i", {
                                    title: option.title,
                                    class: _normalizeClass(`gg-${item[option.use] === 'active' ? 'lock-unlock' : 'lock'} cursor-pointer hover:text-primary`)
                                  }, null, 10, _hoisted_21)
                                ], 8, _hoisted_20))
                              : (option.icon === 'block')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    onClick: ($event: any) => (option.action(item))
                                  }, [
                                    _createElementVNode("i", {
                                      title: option.title,
                                      class: _normalizeClass(`gg-${option.icon} cursor-pointer hover:text-primary`)
                                    }, null, 10, _hoisted_23)
                                  ], 8, _hoisted_22))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 3,
                                    to: `${option.path}/${item.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("i", {
                                        title: option.title,
                                        class: _normalizeClass(`gg-${option.icon} mx-3 cursor-pointer hover:text-primary`)
                                      }, null, 10, _hoisted_24)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                        ], 64))
                      }), 128))
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" No items found... ", -1),
            _createElementVNode("i", { class: "ml-3 gg-ghost-character" }, null, -1)
          ]))])),
      _createElementVNode("div", _hoisted_26, [
        ($props.data)
          ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Showing " + _toDisplayString($setup.indexPagination * $setup.perView) + " - " + _toDisplayString($setup.copyData ? $setup.copyData.length : 0 + $setup.indexPagination * $setup.perView) + " of " + _toDisplayString($props.data ? $props.data.length : 0), 1))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "col-span-2" }, null, -1)),
        _createElementVNode("span", _hoisted_28, [
          _createElementVNode("nav", _hoisted_29, [
            _createElementVNode("ul", _hoisted_30, [
              _createElementVNode("li", null, [
                ($setup.indexPagination > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(`px-3 py-1 rounded-md rounded-l-lg focus:outline-none focus:shadow-outline-${$props.color}`),
                      "aria-label": "Previous",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.indexPagination--))
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        class: "w-4 h-4 fill-current",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", {
                          d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                          "clip-rule": "evenodd",
                          "fill-rule": "evenodd"
                        })
                      ], -1)
                    ]))], 2))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sizeOfList, (position) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: position }, [
                  (position - 1 == $setup.indexPagination)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                        _createElementVNode("button", {
                          class: _normalizeClass(`px-3 py-1 text-white transition-colors duration-150 bg-${$props.color} border border-r-0 border-${$props.color} rounded-md focus:outline-none focus:shadow-outline-${$props.color}`)
                        }, _toDisplayString(position), 3)
                      ]))
                    : (_openBlock(), _createElementBlock("li", _hoisted_32, [
                        (position - 1 <= $setup.indexPagination + 3 &&
                    position > $setup.indexPagination - 1
                    )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => ($setup.indexPagination = position - 1),
                              class: _normalizeClass(`px-3 py-1 rounded-md focus:outline-none focus:shadow-outline-${$props.color}`)
                            }, _toDisplayString(position), 11, _hoisted_33))
                          : _createCommentVNode("", true)
                      ]))
                ], 64))
              }), 128)),
              _createElementVNode("li", null, [
                ($setup.indexPagination < $setup.sizeOfList - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(`px-3 py-1 rounded-md rounded-r-lg focus:outline-none focus:shadow-outline-${$props.color}`),
                      "aria-label": "Next",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.indexPagination++))
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 fill-current",
                        "aria-hidden": "true",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", {
                          d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                          "clip-rule": "evenodd",
                          "fill-rule": "evenodd"
                        })
                      ], -1)
                    ]))], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}